import { Button } from '@depop/web-thrift-ui/Button';

import styles from './styles.module.css';

type ButtonProps = {
  text: string;
  variant: string | null;
};

export function DualPropositionHeroButton({ text, variant }: ButtonProps) {
  return (
    <div className={styles.heroCta}>
      <Button data-variant={variant}>{text}</Button>
    </div>
  );
}
